export default {
  neighbourhoodGuid: "11111111-1111-1111-1111-222222222222",
  foundationId: 1
};
